import './application-for-recognition.scss';

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const formValidation = function () {
  let wrapper = document.querySelector(".webform-submission-form");

  let fields = wrapper.querySelectorAll('input:not([type=submit]):not([type=button]).required, select.required, #edit-terms-and-confiditions, #edit-recognition-code-5-digit');

  let submits = wrapper.querySelectorAll("#moneris-submit, .js-form-submit");

  let casl = wrapper.querySelector("#edit-terms-and-confiditions");

  let emailInput = wrapper.querySelector('#edit-email');

  let recCode5 = wrapper.querySelector('#edit-recognition-code-5-digit');

  //disable onload
  submits.forEach(submit => {
    submit.disabled = true;
  });
  casl.checked = false;

  function validateAllFields(event) {
    let isValid = true;

    //reset button
    submits.forEach(submit => {
      submit.disabled = true;
    });
    isValid = true;

    fields.forEach(item => {
      if (item.value === "") {
        isValid = false;
      }
    });

    if (!validateEmail(emailInput.value)) {
      isValid = false;
    }

    if (recCode5.value.replace(/_/g, '').replace(/ /g, '').length !== 5) {
      isValid = false;
    }

    if (casl.checked === false) {
      isValid = false;
    }

    submits.forEach(submit => {
      if (isValid) {
        submit.disabled = false;
      }
      else {
        submit.disabled = true;
      }
    });
  }

  fields.forEach(field => {
    // some fields don't react on 'change' event, such as recognition-code-5-digit
    field.addEventListener("keyup", validateAllFields);
    field.addEventListener("change", validateAllFields);
  });
};

jQuery(document).ready(function () {

  if (jQuery(".webform-submission-application-for-recognition-form").length > 0) {
    formValidation();
  }


  // Update text with amount payable
  jQuery('input[name ="amount_payable_taxes_included"]').change(function () {
    var text = jQuery('.authorize_amount').text();

    if (parseFloat(this.value) >= 0) {
      jQuery(this).val(parseFloat(jQuery(this).val()).toFixed(2));
      jQuery('.authorize_amount').text(text.replace(/\d+\.?\d*/, this.value));
      jQuery(this).removeClass('error');
      jQuery('.amount_error').removeClass('d-block');
      jQuery('.amount_error').addClass('d-none');
    } else {
      jQuery('.authorize_amount').text(text.replace(/\d+\.?\d*/, 0));
      jQuery(this).addClass('error');
      jQuery('.amount_error').removeClass('d-none');
      jQuery('.amount_error').addClass('d-block');
    }
  });

  var respMsg = function (e) {
    const respData = JSON.parse(e.data);

    //Reset token
    jQuery('input[name ="moneris_token"]').val("");

    if (typeof respData.responseCode !== 'undefined') {
      if (respData.responseCode.toString() === '001') {
        jQuery('input[name ="moneris_token"]').val(respData.dataKey);
      } else {
        jQuery('input[name ="moneris_error"]').val(respData.responseCode);
      }
    }

    if (jQuery('#moneris-submit').hasClass('submitted')) {
      jQuery('#moneris-submit').removeClass('submitted');
      jQuery('#moneris-submit').prop("disabled", true);
      jQuery('form.application-for-recognition').submit();
    }
  };

  window.onload = function () {

    if (jQuery('form.application-for-recognition').length) {
      if (window.addEventListener) {
        window.addEventListener("message", respMsg, false);
      } else {
        if (window.attachEvent) {
          window.attachEvent("onmessage", respMsg);
        }
      }
    }
  };
});


